export default __webpack_public_path__ + "static/media/SndLowerLDownBumpLine.23aa931f.mp3";